module.exports = __webpack_public_path__ + "static/img/014.05a31ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/templates/egyszarnyu-ajto/samples/014.jpg
// module id = 844
// module chunks = 0